/* eslint-disable react/no-direct-mutation-state */
import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/core';
import Calendar from '@toast-ui/react-calendar';
import $ from 'jquery'
import { connect } from "react-redux";
import {removeLastSegment, getLastSegment } from '../Utils/pathHelper';
import { selectShift, updateEmployeeDashboardData } from "../../actions";
import { RequestSource, ShiftSegmentTypeName } from '../../../Enums';
import { CUSTOM_THEME, CalendarStyles } from '../../../styles/styles';
import { renderSchedule } from './calendarFunctions';

var spinnerContainer = document.createElement('div');
spinnerContainer.style.position = 'absolute';
spinnerContainer.style.opacity = 0.5;
spinnerContainer.style.top = 0;
spinnerContainer.style.left = 0;
spinnerContainer.style.pointerEvents = 'none';
spinnerContainer.style.width = '100%';
spinnerContainer.style.height = '100%';
spinnerContainer.style.zIndex = 1;
spinnerContainer.style.overflow = 'hidden';
spinnerContainer.style.backgroundColor = 'rgba(0,0,0,0.10)';

class CustomCalendar extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            seeMore: false,
        };
    }

    componentWillUnmount() {
        clearTimeout(this?.timeoutSpinner);
    }

    generateCalendar = (firstDayOfTheWeek) => {
        const {
            calendarRef: calendarRefFromProps,
            initLoad,
            data,
            currentView,
            calendar,
            visibleWeeksCount,
            globalConfigs
        } = this.props;

        var { seeMore } = this.state;

        if (calendarRefFromProps.current) {
            let calendarRef = calendarRefFromProps.current.getInstance();
            let parsedMonthlySchedule = initLoad ? this.filterCalendars(data.monthlySchedule) : [];
            let parsedWeeklySchedule = initLoad ? this.filterCalendars(data.weeklySchedule) : [];
            let schedule = currentView === 'month' ? parsedMonthlySchedule : parsedWeeklySchedule;//TODO FE refactor: this will always give 'month', remove parsedWeeklySchedule
            calendarRef.setCalendars(calendar);
            if (!seeMore) {
                calendarRef.setOptions(
                    {
                        month: {
                            startDayOfWeek: firstDayOfTheWeek,
                            scheduleFilter: function (schedule) {
                                return Boolean(schedule.isVisible);
                            },
                            visibleWeeksCount: visibleWeeksCount,
                            isAlways6Week: false
                        }
                    });
                calendarRef.clear();
                calendarRef.createSchedules(
                    schedule, true
                );
                calendarRef.render();
                return this.calendarInstance;
            }
            else {

                var items = Object.values(calendarRef._controller.schedules.items);
                let itemsDictionary = items.reduce((acc, val) => {
                    acc[`${val.id || 0}_${val.calendarId || 0}`] = val;
                    return acc;
                }, {});
                let itemsToAdd = !items || !items.length ?
                    schedule : schedule.filter(s => !itemsDictionary[`${s.id || 0}_${s.calendarId || 0}`]);
                calendarRef.createSchedules(
                    itemsToAdd
                );
                this.state.seeMore = false;
                return this.calendarInstance;
            }
            // Update here

        }

        if (globalConfigs.isShowOrganizationalPath) {
            CUSTOM_THEME['month.schedule.height'] = '40px';
        }

        let calendars = calendar;
        let parsedMonthlySchedule = initLoad ? this.filterCalendars(data.monthlySchedule) : []
        let parsedWeeklySchedule = initLoad ? this.filterCalendars(data.weeklySchedule) : []
        this.calendarInstance = <Calendar
            ref={calendarRefFromProps}
            view='month'
            height="87vh"
            calendars={calendars}
            theme={CUSTOM_THEME}
            disableDblClick={true}
            disableClick={true}
            isReadOnly={true}
            month={{
                startDayOfWeek: firstDayOfTheWeek,
                scheduleFilter: function (schedule) {
                    return Boolean(schedule.isVisible);
                },
                visibleWeeksCount: visibleWeeksCount

            }}
            week={{
                startDayOfWeek: firstDayOfTheWeek,
                scheduleFilter: function (schedule) {
                    return Boolean(schedule.isVisible);
                },
            }}
            schedules={currentView === 'month' ? parsedMonthlySchedule : parsedWeeklySchedule}//TODO FE refactor: this will always give 'month', remove parsedWeeklySchedule
            taskView={false}
            scheduleView={['time']}
            template={{
                time: function (schedule) {
                    return renderSchedule(schedule, globalConfigs.isShowOrganizationalPath);
                },
                timegridDisplayPrimaryTime: (time) => {
                    let hour = time.hour;
                    let meridiem = hour >= 12 ? 'pm' : 'am';
                    if (hour > 12) {
                        hour = hour - 12;
                    }
                    return hour + ' ' + meridiem;
                },
                monthGridHeaderExceed: () => '<span class="tui-full-calendar-weekday-grid-more-schedules">See more</span>'
            }}
            usageStatistics={false}
            onClickSchedule={this.handleShiftClick}
            //onClickMore={this.onClickMore}
            onAfterRenderSchedule={this.unbindTitles}
            timezones={[
                {
                    timezoneOffset: 0,
                    displayLabel: 'UTC+0:00'
                }
            ]}
        />;

        return this.calendarInstance;
    }
    /* TODO DELETE ME?
        onClickMore = (async (e) => {
            
            const {
                dateRanges, options, person, statusDictionary, managerSettings, data,
            } = this.props;
    
            if (e.processed) {
                return;
            }
    
            /** @type {HTMLElement} * /
            var target = e.target;
            target.style.position = 'relative';
    
            target.appendChild(spinnerContainer);
            ReactDOM.render(<Spinner showSpinner={true} />, spinnerContainer);
    
            this.timeoutSpinner = setTimeout(() => {
                ReactDOM.unmountComponentAtNode(spinnerContainer);
            }, 500);
    
            let toCoversToAdd = [];
            let monthlySchedule;
    
            await Net.getAvailableShiftToCoverOffers(options, formatAs(e.date, DateFnsFormats.YMD), formatAs(e.date, DateFnsFormats.YMD), 1).then((response) => {
                toCoversToAdd.push(...response.data.offers);
                let availableShiftsToCover = data.availableShiftsToCover;
                let availableShiftsToCoverIds = availableShiftsToCover.map(x => x.offerId);
    
                toCoversToAdd = toCoversToAdd.filter(x => !availableShiftsToCoverIds.includes(x.offerId))
                availableShiftsToCover = [...availableShiftsToCover, ...toCoversToAdd];
                monthlySchedule = UI.generateSchedule(
                    true,
                    data.employeeShifts,
                    data.employeeShiftOffers,
                    availableShiftsToCover,
                    data.employeeShiftRequests,
                    data.employeeMyShiftSwapOffers,
                    data.availableShiftToSwapOffers,
                    data.employeePaycodes,
                    data.myProposals,
                    data.availableOpenShifts, // TODO: OPEN SHIFT
                    data.myOpenShiftRequests,
                    data.availableVTO,
                    data.myVTORequests,
                    statusDictionary,
                    person.personName,
                    managerSettings,
                    dateRanges,
                )
                this.state.seeMore = true;
            }
            )
            this.props.updateEmployeeDashboardData({ monthlySchedule: monthlySchedule })
            
            if (e.callback) {
                e.callback()
            }
        }
        )
    */
    isIncludedInLocationFilter = (shiftSegments, locations, isTransferIncluded) => {
        const segments = isTransferIncluded 
            ? shiftSegments.filter(x => x.type !== ShiftSegmentTypeName.BREAK_SEGMENT) 
            : shiftSegments.filter((segment) => segment.type !== ShiftSegmentTypeName.BREAK_SEGMENT && segment.type !== ShiftSegmentTypeName.TRANSFER_SEGMENT);
        return segments.some((segment) => locations.includes(removeLastSegment(segment.orgJobRef.qualifier)));
    } 

    isIncludedInJobFilter = (shiftSegments, jobs, isTransferIncluded) => {
        const segments = isTransferIncluded 
            ? shiftSegments.filter(x => x.type !== ShiftSegmentTypeName.BREAK_SEGMENT) 
            : shiftSegments.filter((segment) => segment.type !== ShiftSegmentTypeName.BREAK_SEGMENT && segment.type !== ShiftSegmentTypeName.TRANSFER_SEGMENT);
        return segments.some((segment) => jobs.includes(getLastSegment(segment.orgJobRef.qualifier)));
    } 

    filterCalendars = (schedule) => {
        let parsedSchedule = []
        const { selectedShifts, selectedOpenShifts, filtersDefinition } = this.props

        const myItems = filtersDefinition.myItem.filters;
        const myRequest = filtersDefinition.myRequest.filters;
        const status = filtersDefinition.status.filters;
        const locationCheckedValues = filtersDefinition.location.filters.filter(x => x.checked).map(x => x.name);
        const isLocationTransferIncluded = filtersDefinition.location.isTransferIncluded;
        const jobCheckedValues = filtersDefinition.job.filters.filter(x => x.checked).map(x => x.name);
        const isJobTransferIncluded = filtersDefinition.job.isTransferIncluded;
        const skipValidationFilters = filtersDefinition.skipValidationOffers.filters;

        for (let item of schedule) {
            let isVisible = true;
            let checkStatus = true;
            let settingFilter;

            if (item.isSkipValidation) {
                settingFilter = skipValidationFilters.find(filter =>
                    filter.calendarIds && filter.calendarIds.includes(item.managerSettingId.toString())
                );
                checkStatus = false;
            } else if ([0, 1].includes(parseInt(item.calendarId))) { // Shifts and paycode
                settingFilter = myItems.find(filter => filter.id === parseInt(item.calendarId));
                checkStatus = false;
            } else if (item.raw.source === RequestSource.Offerer) {
                settingFilter = myRequest.find(filter => filter.calendarIds.includes(item.managerSettingId.toString()));
            } else if (item.raw.source === RequestSource.Requester) {
                if (item.raw.isAvailableOffer) {
                    settingFilter = myItems.find(filter => filter.calendarIds.includes(item.managerSettingId.toString()));
                } else {
                    settingFilter = myRequest.find(filter => filter.calendarIds.includes(item.managerSettingId.toString()));
                }
            }

            if (!settingFilter || !settingFilter.checked) {
                isVisible = false
            } else if (checkStatus) {
                let statusFilter;
                if (item.raw.isOwnProposals) {
                    statusFilter = status.find(filter => filter.statusIds.includes(item.raw.proposals[0].status))
                } else {
                    statusFilter = status.find(filter => filter.statusIds.includes(item.raw.status));
                }

                if (!statusFilter || !statusFilter.checked) {
                    isVisible = false;
                }
            }

            if (isVisible) {
                if (item.raw.segments) {
                    isVisible = this.isIncludedInLocationFilter(item.raw.segments, locationCheckedValues, isLocationTransferIncluded);
                } else if (item.raw.shift?.segments) {
                    isVisible = this.isIncludedInLocationFilter(item.raw.shift.segments, locationCheckedValues, isLocationTransferIncluded);
                } else if (item.raw.shifts) {
                    isVisible = item.raw.shifts.some((shift) => {
                        return this.isIncludedInLocationFilter(shift.segments, locationCheckedValues, isLocationTransferIncluded);
                    });
                }
            }

            if (isVisible) {
                if (item.raw.segments) {
                    isVisible = this.isIncludedInJobFilter(item.raw.segments, jobCheckedValues, isJobTransferIncluded);
                } else if (item.raw.shift?.segments) {
                    isVisible = this.isIncludedInJobFilter(item.raw.shift.segments, jobCheckedValues, isJobTransferIncluded);
                } else if (item.raw.shifts) {
                    isVisible = item.raw.shifts.some((shift) => {
                        return this.isIncludedInJobFilter(shift.segments, jobCheckedValues, isJobTransferIncluded);
                    });
                }
            }


            if (selectedShifts.find(shift => shift.id === item.id) || (selectedOpenShifts.find(shift => shift.key === item.id
                && shift.managerSettingId === item.raw.managerSettingId))) {
                parsedSchedule.push({ ...item, isVisible: isVisible, raw: { ...item.raw, isChecked: true } })
            } else {
                parsedSchedule.push({ ...item, isVisible: isVisible, raw: { ...item.raw, isChecked: false } })
            }
        }

        return parsedSchedule;
    }

    unbindTitles = () => {
        $('.tui-full-calendar-weekday-schedule-title').removeAttr('title');
        $('.tui-full-calendar-weekday-schedule-bullet').css('top', 0)
        $('.tui-full-calendar-weekday-schedule-title').css('line-height', '18px')
        let tooltips = $('.tooltiptext')
        tooltips.each((_, value) => {
            let tooltip = $(value)[0];
            let parent_rect = $(tooltip).parent()[0].getBoundingClientRect()
            let tooltip_rect = tooltip.getBoundingClientRect();
            // Realign the arrow to the hovered element
            $(tooltip).children('.tooltip-arrow').removeAttr('style')
            let wrapper = $('#calendarContainer');
            let wrapper_rect = wrapper[0].getBoundingClientRect();
            if ((tooltip_rect.x + tooltip_rect.width) > wrapper_rect.width) { // Out on the right
                $(tooltip).css({ right: 0, left: '' })
                $(tooltip).children('.tooltip-arrow').css({ right: (parent_rect.width / 2) })
            }
            else if (tooltip_rect.x - tooltip_rect.width < wrapper_rect.x) { // Out on the left
                $(tooltip).addClass('tooltiptext-top-right')
                $(tooltip).css({ left: 0 })
                $(tooltip).children('.tooltip-arrow').css({ left: (parent_rect.width / 2) })
            }
            else { // Inside the bounding box
                $(tooltip).css({ left: -(tooltip_rect.width / 2 - parent_rect.width / 2) })
                $(tooltip).children('.tooltip-arrow').css({ left: (tooltip_rect.width / 2) })
            }
            if (tooltip_rect.y < wrapper_rect.y) {
                $(tooltip).css({ bottom: -(tooltip_rect.height + 10) })
                $(tooltip).children('.tooltip-arrow').addClass('tooltip-top-arrow')
            }

        })
    }

    handleShiftClick = (event) => {
        if (event.event.target.type === 'checkbox') {
            if (event.schedule.calendarId === '0') {
                this.props.handleMultiSelectShift(event.schedule)
            }
            else {
                this.props.handleMultiSelectOpenShift(event.schedule)
            }
        } else {
            if (event.schedule.calendarId === -1) {
                //this.onClickMore({ date: event.schedule.start })
            }
            else if (event.schedule.calendarId !== '1') {
                this.props.handleShiftClick(event);
            }
        }
    }

    render() {
        const { firstDayOfTheWeek, globalConfigs } = this.props;

        const calendar = globalConfigs.isLoaded ? this.generateCalendar(firstDayOfTheWeek) : <></>;

        return (
            <React.Fragment>
                {calendar}
            </React.Fragment>
        )
    }
}


const mapStateToProps = state => {
    return {
        filtersDefinition: state.filters,
        calendar: state.calendar,
        globalConfigs: state.globalConfigs,
        selectedShifts: state.selectedShifts,
        selectedOpenShifts: state.selectedOpenShifts,
        statusDictionary: state.statusDictionary,
        data: state.data,
        options: state.httpOptions,
        person: state.person,
        managerSettings: state.managerSettings,
        dateRanges: state.dateRanges,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        selectShift: (payload) => dispatch(selectShift(payload)),
        updateEmployeeDashboardData: payload => dispatch(updateEmployeeDashboardData(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(CalendarStyles)(CustomCalendar));